import { POST, PUT, request, useDynamicCallback, useEndpointsContext, type LedgerUpdateTypeEnum } from '@talos/kyoko';

export const PositionTypeEnum = {
  MarketAccountPosition: 'MarketAccountPosition',
  SubAccountPosition: 'SubAccountPosition',
} as const;
export type PositionTypeEnum = (typeof PositionTypeEnum)[keyof typeof PositionTypeEnum];

export interface UpdatePositionParams {
  Type: LedgerUpdateTypeEnum;
  IntendedType: LedgerUpdateTypeEnum;
  AccountName: string;
  Asset: string;
  Amount: string;
  AvgCost?: string;
  AvgCostCurrency?: string;
  LastUpdateTime?: string;
  Comments?: string;
}

export interface RecalculateSubAccountHistoryParams {
  TransactTime: string;
  ExternalID: string;
  AccountName?: string;
}

export const usePositionRequests = () => {
  const { orgApiEndpoint } = useEndpointsContext();

  const updatePosition = useDynamicCallback((params: UpdatePositionParams, positionType: PositionTypeEnum) => {
    // Note that we are passing an array of params here, the backend accepts an array but for now for simplicity we just allow one update in this function
    return request(
      PUT,
      `${orgApiEndpoint}/positions/${
        positionType === PositionTypeEnum.MarketAccountPosition ? 'market-accounts' : 'subaccounts'
      }`,
      [params]
    );
  });

  const recalculateSubAccountHistory = useDynamicCallback((params: RecalculateSubAccountHistoryParams) => {
    return request(POST, `${orgApiEndpoint}/position-stats/recalc`, params);
  });

  return {
    updatePosition,
    recalculateSubAccountHistory,
  };
};
